import {Component} from '@angular/core';
import {ToastService} from "../../../../core/services/toast.service";
import {CommonService} from "../../../../core/services/common.service";
import {ActivatedRoute, Router} from "@angular/router";
import {HttpClientService} from "../../../../core/services/http-client.service";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent {
  user: any = {
    exists: false,
    otpCode: null,
    mobile: null,
    referenceId: null
  };
  private customer: any;
  constructor(private toast: ToastService, private common: CommonService, private route: ActivatedRoute, private http: HttpClientService, private _router: Router) {}


  ngOnInit() { }

  back() {
    window.location.reload();
  }

  requestOtp() {
    const params = this.user;
    this.http.get("store/otp/generateOTP", params).subscribe(response => {
      if (response.responseStatus.toLowerCase() == 'success') {
        this.user.referenceId = response.response.reference_id;
      }
    });
  }

  verifyOtp() {
    const params = this.user;
    this.http.get("otp/verifyOTP", this.common.stringParams(params)).subscribe(response => {
      if (response.response.result) {
        this._router.navigateByUrl("/register?mobile=" + this.user.mobile);
      } else {
        this.toast.error('Please enter a valid OTP');
      }
    });
  }

  goToPage(url): void {
    url = `/${url}`;
    this._router.navigateByUrl(url);
  }

  signUpOrLogin() {
    const mobile = this.user.mobile.toString();
    if (this.user.referenceId) this.verifyOtp();
    if (mobile && mobile.length == 10) {
      this.http.get(`store/checkmobile/${mobile}`).subscribe((res) => {
        if (res.responseStatus.toLowerCase() == 'success') {
          const customerResponse = res.response;
          if (customerResponse.exists) {
            this.user.exists = true;
            this.customer = customerResponse.customer;
            this._router.navigateByUrl("/login?customerId=" + this.customer.id);
          } else {
            this.requestOtp();
          }
        } else {
          this.toast.error("Server error")
        }
      })
    } else {
      this.toast.error(`Please enter a valid mobile number`);
      return false;
    }
  }
}
